<template>
  <!-- Listagem -->
  <div>
    <!-- Filtros -->
    <v-row v-if="avaliacoes.length > 1" no-gutters>
      <v-col cols="12">
        <app-title texto="FILTROS" />
        <avaliacao-filter :value="filtros" :perspectiva="perspectiva" />
      </v-col>
    </v-row>

    <!-- Itens avaliados -->
    <v-row no-gutters class="mt-4">
      <v-col cols="12">
        <app-title texto="ITENS AVALIADOS" />
        <v-data-table :headers="headers" :items="itensView">
          <!-- Edição da nota -->
          <template v-slot:[`item.rating`]="{ item }">
            <app-rating
              :value="item.nota"
              :disabled="disabled"
              @return="item.naoAplica = false; editar(item)"
            />
          </template>

          <!-- Não aplica ignora o servidor -->
          <template v-slot:[`item.switch`]="{ item }">
            <v-switch
              v-model="item.naoAplica"
              :disabled="item.naoAplica || disabled"
              class="ma-2"
              label="Não se aplica"
              dense
              @change="item.nota.rating = 0; editar(item)"
            />
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import AppTitle from '@/components/core/AppTitle';
import AppRating from '@/components/core/AppRating';
import AvaliacaoFilter from '@/components/diagnostico/AvaliacaoFilter';

const itemAvaliacaoRepository = RepositoryFactory.get('itemAvaliacao');

export default {
  name: 'AvaliacaoList',

  components: { AppTitle, AppRating, AvaliacaoFilter },

  props: {
    avaliacoes: {
      type: Array,
      required: true,
    },
    lista: {
      type: Array,
      required: true,
    },
    escalas: {
      type: Array,
      required: true,
    },
    tipo: {
      type: String,
      required: true,
    },
    perspectiva: {
      type: String,
      required: true,
    },
    isAvaliacaoGestores: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      filtros: {
        servidores: {
          opcoes: this.avaliacoes.map((a) => ({
            avaliacao: a.id,
            avaliado: a.avaliado.id,
            nomeAvaliado: a.avaliado.nome,
          })),
          selecionado: [],
        },
        lista: {
          opcoes: [...this.lista],
          selecionado: [],
        },
        notas: {
          opcoes: [...this.escalas],
          selecionado: [],
        },
      },
    };
  },

  computed: {
    itemProp() {
      return this.perspectiva === 'COMPORTAMENTAL' ? 'fator' : 'responsabilidade';
    },
    itemTextProp() {
      return this.perspectiva === 'COMPORTAMENTAL' ? 'descricaoAtualizada' : 'tituloAtual';
    },
    itens: {
      get() {
        return this.$store.state.diagnostico.itens;
      },
      set(itens) {
        this.$store.dispatch('diagnostico/setItens', itens);
      },
    },
    itensView() {
      return this.itens.filter(
        (i) => this.avaliacoes.some((a) => a.id === i.avaliacao.id)
        && (
          this.filtros.servidores.selecionado.length === 0
          || this.filtros.servidores.selecionado.some((s) => s.avaliado === i.avaliacao.avaliado.id)
        )
        && (this.filtros.lista.selecionado.length === 0
          || this.filtros.lista.selecionado.some((c) => c.id === i[this.itemProp].id)
        )
        && (
          this.filtros.notas.selecionado.length === 0
          || this.filtros.notas.selecionado.some((n) => n.id === i.nota.id)
        ),
      ).sort((a, b) => a[this.itemProp][this.itemTextProp].localeCompare(b[this.itemProp][this.itemTextProp]));
    },
    headers() {
      const headers = [
        {
          text: this.perspectiva === 'COMPORTAMENTAL' ? 'COMPORTAMENTO' : 'RESPONSABILIDADE',
          value: `${this.itemProp}.${this.itemTextProp}`,
          sortable: false,
        },
        {
          text: '',
          sortable: false,
          value: 'rating',
          align: 'end',
          width: '15%',
        },
      ];

      if (this.avaliacoes.length > 1) {
        headers.splice(1, 0, { text: 'AVALIADO', value: 'avaliacao.avaliado.nome', sortable: false });
      }

      if (this.tipo === 'SUBORDINADO' && this.perspectiva === 'RESPONSABILIDADE' && !this.isAvaliacaoGestores) {
        headers.push({
          text: '',
          sortable: false,
          value: 'switch',
          align: 'end',
          width: '15%',
        });
      }

      return headers;
    },
  },

  methods: {
    editar(item) {
      const payload = {
        ...item,
        nota: this.getNota(item.nota.rating),
      };

      itemAvaliacaoRepository.update(payload).then((response) => {
        const item = response.data;
        const index = this.itens.findIndex((i) => i.id === item.id);

        if (index !== -1) {
          item.nota = item.nota || { rating: 0 };
          this.itens.splice(index, 1, item);
        }

        this.$store.dispatch('app/success', { response, message: 'Avaliação editada com sucesso!' });
      });
    },
    getNota(rating) {
      const index = this.escalas.findIndex((e) => e.rating === rating);
      if (index !== -1) {
        return this.escalas[index];
      }
    },
  },
};
</script>
